import "./App.css";
import AppRoutes from "./components/routes/AppRouter";

function App() {
  return (
    <div className="App">
      <AppRoutes />
    </div>
  );
}

export default App;
